/* eslint-disable react-hooks/exhaustive-deps */
// components/Counter.tsx
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/reducers";
import "./invoice.scss";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../store";
import HomeBanner from "../../components/HomeBanner/HomeBanner";
import ShareInvoiceQrcode from "../../components/shareInvoiceQrcode/shareInvoiceQrcode";
import QRCodeStyling from "qr-code-styling";
import { apiService } from "../../services";
import TableInfo from "../../components/tableInfo";
import Adds from "../../components/Adds/Adds";
import { useTranslation, withTranslation } from "react-i18next";
import NotFound from "../Found";
import { Skeleton, CircularProgress, Button } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import axios from "axios";
import { checkExpire } from "../../utils/genral-functions";
import { convertTo12HourFormat } from "../../utils/genral-functions";
import { sortedByNumber } from "../../utils/genral-functions";
import {
  GoogleCalandarEvent,
  handleGoogle,
} from "../../global-functions/googleCalandarEvent";

import knetSmall from "../../assets/images/knet.png";
import credit from "../../assets/images/credit.png";
import applePayIcon from "../../assets/images/pat-apple-n.svg";

import { gapi } from "gapi-script";
import QrCodeIcon from "@mui/icons-material/QrCode";

import QRCode from "react-qr-code";
import NewNextBtn from "../../components/BtnNext/NewNextBtn";
import { getCookie, erase, setCookie } from "../../helper/cookieFunction";
import { formatTime } from "../../utils/genral-functions";
import moment from "moment";
import { get_lang } from "../../helper/getLang";
import PaymentMethods from "../../components/paymentMethods/paymentMethods";
import LoginModalv2Popup from "../../components/loginSignUp/LoginModalv2Popup";
import VerifyPhoneNumberv2Popup from "../../components/loginSignUp/VerifyPhoneNumberv2Popup";

const qrCode = new QRCodeStyling({
  width: 180,
  height: 180,
  dotsOptions: {
    color: "#000",
    type: "square",
  },
  imageOptions: {
    crossOrigin: "anonymous",
    margin: 15,
  },
});
const Invoice = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { slug='enabill', id }: any = useParams();
  const { search } = useLocation();
  const searchParams: any = new URLSearchParams(search);
  const [comeFromAuth, setComeFromAuth] = useState(searchParams.has('appLoggedIn'));
  const authMountRef = useRef(false);
  // let paidByCash = ['haute-dolci-online','kul-kuwait-city'].includes(slug);
  const [paidByCash, setpaidByCash] = useState(false)
  
  // Check if ID is a number or encrypted
  const isNumericId = !isNaN(Number(id)) && id !== '' && !isNaN(parseFloat(id));
  let encryptedId = id;
  let finalDecodedId = id;
  
  if (isNumericId) {
    // If ID is a number, encrypt it twice for URL
    try {
      encryptedId = btoa(String(id));
      encryptedId = btoa(encryptedId);
    } catch (error) {
      console.error("Error encoding invoice ID:", error);
      encryptedId = id;
    }
    finalDecodedId = id; // Use the number as-is for API calls
  } else {
    // If ID is already encrypted, decode it twice for API calls
      try {
        finalDecodedId = atob(id);
        finalDecodedId = atob(finalDecodedId);
      } catch (error) {
        console.error("Error decoding invoice ID:", error);
        finalDecodedId = id;
      }
      encryptedId = id; // Keep encrypted version for URL
  }
  
  const apiState = useSelector((state: RootState) => state.apiReducer);
  const appState = useSelector((state: RootState) => state.appReducer);
  const { freezScreen, paymentMethodPopUp, pendingCheckout, loginValues, loginModal } = appState;
  const { storeId, storeInfo,userInfo } = apiState;
  const { freezScreenState, alertMessageState, setRedirectCheckout, setStoreInfo, setBookingDetails, setPaymentMethodPopUp, setAuthToken, userInfoState, setLoginModal, setPendingCheckout } = bindActionCreators(
    actionCreators,
    dispatch
  );
  const [adds, setAdds] = useState({});
  const [showAdds, setShowAdds] = useState(false);
  const ref = useRef(null);
  const [url, setUrl] = useState(
    `${process.env.REACT_APP_BOOKING_URL}/invoice/${encryptedId}`
  );
  const [notFound, setNotFound] = useState(false);
  const [branchId, setBranchId]: any = useState(null);
  const [branchSlug, setBranchSlug] = useState(null)
  const [invoiceData, setinvoiceData]: any = useState(null);
  const [googleAccessToken, setgoogleAccessToken] = useState(null);
  const [calandarId, setcalandarId] = useState(null);
  const [bookingInvoiceInfo, setBookingInvoiceInfo]: any = useState({})
  const [showThis, setShowThis] = useState(false);
  const [decodedId, setDecodedId] = useState(finalDecodedId);
  const [paymentMethod, setPaymentMethod] = React.useState(null);
  const [tapId, setTapId]: any = useState("");
  const [isPaymentLoading, setIsPaymentLoading] = useState(false);
  const [cardDetails, setcardDetails] = useState(null);
  const childRef: any = useRef();
  const gettingAdversting = async (branchID: any) => {
    let addRes: any = await apiService.getAdvertising(branchID);
    if (addRes.data.success) {
      if (addRes.data.data?.length > 0) {
        setAdds(addRes.data.data[0]);
        setShowAdds(true);
      }
    }
  };

console.log(paymentMethod,'paymentMethod')
  
  const getStore = async (branchSlug: any) => {
    if(slug != branchSlug && branchSlug != 'invoice' && branchSlug != 'in' && branchSlug != "undefined" ){
      freezScreenState(true);
      let id: any = null;
      let response: any = null;
  
      try {
        response = await axios.post(
          `${process.env.REACT_APP_API_URL}/branch/${branchSlug}`,
          {} ,
          { headers: { Response: "detail" } }
        );
      } catch (e: any) {
        response = e?.response;
        if(slug != "invoice"){
          navigate(`/${slug}/404`);
        }
        console.error("New Api store not found", e);
      }
  
      if (response?.data.success === true) {
        let branchObj: any = response?.data?.data;
        id = branchObj?.id;
        let data = response?.data?.data?.store;
        let bookingObj = response?.data?.data?.booking;
        let bookingData = {
          title: bookingObj?.title ?? null,
          logo: bookingObj?.logo ?? null,
          cover: bookingObj?.cover ?? null,
          description: bookingObj?.description ?? null,
          primaryColor: bookingObj?.primary_color ?? null,
          secondryColor: bookingObj?.secondry_color ?? null,
          bg_image: bookingObj?.bg_image  ?? null
        };
          
          if (bookingData?.primaryColor) {
            document.documentElement.style.setProperty("--th-primary", bookingData?.primaryColor);
        }
        if (bookingData?.secondryColor) {
          document.documentElement.style.setProperty("--th-secondary",bookingData?.secondryColor);
        }
        let storeData: any = {
          bookingInfo: bookingData ?? null,
          businessName: data?.business?.name ?? `Not Avalaible`,
          storeId: data?.id ?? `Not Avalaible`,
          slug: data?.slug ?? `Not Avalaible`,
          logo: data?.business?.logo ?? `Not Avalaible`,
          cover: data?.business?.cover ?? `Not Avalaible`,
          primaryColor: data?.business?.color?.primary ?? `Not Avalaible`,
          secondaryColor: data?.business?.color?.secondary ?? `Not Avalaible`,
          currencySymbol: data?.business?.currency == "SAR" ? "SAR" : "KD",
          storeCurrency: { en: "KWD", ar: "دينار" },
          branchName: branchObj?.name ?? `Not Avalaible`,
          numberFixed: 3,
          storeBusyTime: data?.busy_till,
          tapKey: branchObj?.tap_account?.public_key,
          tap: branchObj?.tap_account != null,
          otp: data?.otp,
          storeCategory: data?.store_category,
          roundLevel:
            data?.rounding != undefined
              ? data?.rounding?.level != undefined
                ? data?.rounding?.level
                : 0.001
              : 0.001,
          roundMethod:
            data?.rounding != undefined
              ? data?.rounding?.method != undefined
                ? data?.rounding?.method
                : "average"
              : "average",
          subCategory: data?.multiple_category,
          categoryProductImage:
            data?.shop_image != undefined || null ? data?.shop_image : true,
          meatSource: data?.meat_source,
          buffetMode: data?.id == 276 ? true : false, //276,
          checkoutShortCut: data?.direct_checkout,
          payments:branchObj?.payments,
          bookingBackground:  bookingData?.bg_image
        };
  
        setStoreInfo(storeData);
        freezScreenState(false);

  
      } else {
        freezScreenState(false);
        alertMessageState({
          type: "error",
          show: true,
          message: response.data.message,
        });
      }
    }
  };

  const handleInvoice = async () => {
    freezScreenState(true);
    // Use the final decoded ID (number) for API calls
    let invoiceRes: any = await apiService.getInvoice(finalDecodedId);
    if (invoiceRes?.data?.success) {
      let data = invoiceRes.data.data;
      setBranchId(data?.branch?.id);
      setBranchSlug(data?.branch?.slug);
      setpaidByCash(['haute-dolci-online','kul-kuwait-city'].includes(data?.branch?.slug));
      getStore(data?.branch?.slug);
      setBookingInvoiceInfo((prev: any) => ({...prev, 
        paidAmount: data?.transaction?.amount,
        paymentMethod:  data?.transaction?.payment_source ?? null,
        bookingDate: data?.booking_date,
        guests: data?.guests,
        packageName: data?.package?.name,
        bookingEndTime: data?.time?.ending ? formatTime(data?.time?.ending) : 'N/A',
        bookingTime: data?.time?.starting ? moment(data?.time?.starting, 'HH:mm').format('h:mm A') : 'N/A',
        bookingCreateDate: data?.package 
          ? moment(data?.created_at).format('DD/MM/YYYY') 
          : data?.transaction?.captured?.date 
            ? moment(data?.transaction?.captured?.date).format('DD/MM/YYYY') 
            : data?.created_at ? moment(data?.created_at).format('DD/MM/YYYY') : 'N/A',
        bookingCreateTime: data?.package 
          ? moment(data?.created_at).format('h:mm A') 
          : data?.transaction?.captured?.time 
            ? moment(data?.transaction?.captured?.time, 'HH:mm').format('h:mm A') 
            : data?.created_at ? moment(data?.created_at).format('h:mm A') : 'N/A',
      }));
      let tryAgainUrl = `${process.env.REACT_APP_BOOKING_URL}/`;
      setinvoiceData(invoiceRes.data.data);
    } else {
      setNotFound(true);
    }
    freezScreenState(false);
  };


  const handleCalendarEvent = () => {
    handleGoogle(setgoogleAccessToken, setcalandarId, alertMessageState);
  };

  const goToAuth = (resumeCheckout = true) => {
    if (storeInfo?.otp && getCookie("tokenAuth") && getCookie("Profile")) {
      freezScreenState(true);
      setAuthToken(getCookie("tokenAuth"));
      userInfoState(JSON.parse(getCookie("Profile")));
    } else {
      freezScreenState(false);
      setPendingCheckout(!!resumeCheckout);
      setLoginModal(true);
    }
  };

  const hasGuestContact = () =>
    !!(loginValues?.fullName?.trim() && loginValues?.phoneNumber);

  const needsContact = () => {
    if (storeInfo?.otp) {
      return !getCookie("tokenAuth") && !getCookie("Profile");
    }
    return !hasGuestContact();
  };

  const handlePayment = async () => {
    setIsPaymentLoading(true);
    let payload = {
      payment_source: paymentMethod || "knet",
      token: tapId != "" ? tapId : null,
      save_card: false,
      card_id: null,
      customer_id: JSON.parse(getCookie("Profile"))?.customerId ? JSON.parse(getCookie("Profile"))?.customerId : null,
      first_name: JSON.parse(getCookie("Profile"))?.userFirstName ? JSON.parse(getCookie("Profile"))?.userFirstName : null,
      card_detail: cardDetails ? cardDetails : null
    };
    console.log(payload,'payload')
    console.log(JSON.parse(getCookie("Profile")),'JSON.parse(getCookie("Profile"))?.firstName')
    try {
      const response: any = await apiService.payBookingInvoice(finalDecodedId, payload);
      
      if (response?.data?.success === true) {
        if (response.data.data?.url && response.data.data?.url != null) {
          setRedirectCheckout(true);
          const winUrl: any = window.open(`${response.data.data.url}`, "_self");
          winUrl.focus();
        } else {
          alertMessageState({
            type: "success",
            show: true,
            message: response?.data?.message || "Payment successful",
          });
          setIsPaymentLoading(false);
          // Reload invoice to get updated status
          handleInvoice();
        }
      } else {
        setIsPaymentLoading(false);
        alertMessageState({
          type: "error",
          show: true,
          message: response?.data?.message || "Payment failed",
        });
      }
    } catch (error: any) {
      setIsPaymentLoading(false);
      console.error("Payment error:", error);
      alertMessageState({
        type: "error",
        show: true,
        message: error?.response?.data?.message || "Payment failed",
      });
      if (error?.response?.status == 401) {
        erase("tokenAuth");
        erase("Profile");
        goToAuth(true);
      }
    }
  };

  const handleCheckoutFunc = async () => {
    if (needsContact()) {
      goToAuth(true);
    } else {
      if (paymentMethod == "card") {
        setIsPaymentLoading(true);
        childRef?.current?.submitRequest();
      } else {
        handlePayment();
      }
    }
  };

  useEffect(() => {
    const ready = storeInfo?.otp
      ? getCookie("tokenAuth") && getCookie("Profile")
      : hasGuestContact();
    if (pendingCheckout && ready && !loginModal) {
      setPendingCheckout(false);
      if (paymentMethod == "apple_pay") return;
      if (paymentMethod == "card") {
        setIsPaymentLoading(true);
        childRef?.current?.submitRequest();
      } else {
        handlePayment();
      }
    }
  }, [pendingCheckout, appState.authToken, loginValues, loginModal]);

  useEffect(() => {
    if (tapId != null && tapId != "" && paymentMethod) {
      handlePayment();
    }
  }, [tapId]);

  useEffect(() => {
    if (ref.current != null) {
      qrCode.append(ref.current);
    }

    // If ID is numeric, update browser URL to use encrypted version
    if (isNumericId && encryptedId !== id) {
      const newPath = window.location.pathname.replace(`/${id}`, `/${encryptedId}`);
      window.history.replaceState({}, '', newPath);
    }

    handleInvoice();
    setRedirectCheckout(false)
  }, []);
  useEffect(() => {
    if (branchId) {
      gettingAdversting(branchId);

    }

  }, [branchId]);
  useEffect(() => {
    if (branchSlug != 'invoice' && branchSlug != 'in' && branchSlug != "undefined" ) {
      setShowThis(branchSlug == 'levels-desert' || branchSlug == 'kul-kuwait-city' && paidByCash);
    }
  }, [branchSlug,paidByCash]);

  useEffect(() => {
    qrCode.update({
      data: url,
    });
  }, [url]);

  useEffect(() => {
    // skip this effect
    return;
    if (
      invoiceData &&
      invoiceData.booking_date &&
      invoiceData.time &&
      invoiceData.time.starting &&
      invoiceData.time.ending && false
    ) {
      var startTime: Date = new Date(
        `${invoiceData.booking_date}T${invoiceData.time.starting}:00`
      );
      var endTime: Date = new Date(
        `${invoiceData.booking_date}T${invoiceData.time.ending}:00`
      );
      var startTimeUTC: string = startTime.toISOString();
      var endTimeUTC: string = endTime.toISOString();

      var event = {
        summary: `${calandarId} Booking`,
        location: "kuwait",
        description: "Table Booking",
        start: {
          dateTime: "2020-06-28T09:00:00-07:00",
          timeZone: "Asia/Kuwait",
        },
        end: {
          dateTime: "2020-06-28T17:00:00-07:00",
          timeZone: "Asia/Kuwait",
        },
        recurrence: ["RRULE:FREQ=DAILY;COUNT=2"],
        attendees: [{ email: `${calandarId} Booking` }],
        reminders: {
          useDefault: false,
          overrides: [
            { method: "email", minutes: 24 * 60 },
            { method: "popup", minutes: 10 },
          ],
        },
      };
      if (googleAccessToken != null && calandarId != null) {
        GoogleCalandarEvent(
          event,
          googleAccessToken,
          calandarId,
          alertMessageState
        );
      }
    }
    console.log(invoiceData);

  }, [googleAccessToken, calandarId, invoiceData]);

  return (
    <React.Fragment>
      <LoginModalv2Popup />
      <VerifyPhoneNumberv2Popup />
      {freezScreen ? (
    <div>
      <Skeleton variant="rounded" width={`100%`} height={200} />
      <Skeleton width={`50%`} height={80} />
      <Skeleton
        className="my-4"
        variant="rounded"
        width={`100%`}
        height={180}
      />
      <Skeleton
        className="my-4"
        variant="rounded"
        width={`100%`}
        height={180}
      />
      <Skeleton
        className="my-4"
        variant="rounded"
        width={`100%`}
        height={180}
      />
    </div>
    
  ) : (
    <React.Fragment>
      <LoginModalv2Popup />
      <VerifyPhoneNumberv2Popup />
      {notFound ? (
        <NotFound />
      ) : (
        <div id="invoice">
          {showAdds ? <Adds data={adds} /> : <HomeBanner corner={false} />}
          <div className="px">
            {(invoiceData?.status?.id === 1 && !paidByCash) ? (
              <div className="d-flex flex-column align-items-center justify-content-center">
                <h1 className="text-center pending familysora600 mt-3">Your Booking is pending.</h1>
                
                {/* Invoice Details Section for Pending Status */}
                {invoiceData && (
                  <div className="row mx-0 mt-3 mb-3" style={{ width: '100%' }}>
                    <div className="col-12" style={{
                      backgroundColor: '#ffffff',
                      borderRadius: '12px',
                      padding: '16px',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                      border: '1px solid #e8e8e8'
                    }}>
                      {/* Invoice Details List */}
                      <div style={{ marginBottom: '12px' }}>
                        {(bookingInvoiceInfo?.guests || invoiceData?.guests) && (
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            padding: '10px 0', 
                            borderBottom: '1px solid #f0f0f0',
                            direction: appState.langValue === "ar" ? "rtl" : "ltr"
                          }}>
                            <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>👥</span> {t("Guests")}
                            </span>
                            <span className="familysora600" style={{ fontSize: '15px', color: '#000', direction: 'ltr' }}>
                              {bookingInvoiceInfo?.guests || invoiceData?.guests || 'N/A'}
                            </span>
                          </div>
                        )}

                        {(bookingInvoiceInfo?.packageName || invoiceData?.package?.name) && (
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            padding: '10px 0', 
                            borderBottom: '1px solid #f0f0f0',
                            direction: appState.langValue === "ar" ? "rtl" : "ltr"
                          }}>
                            <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>📦</span> {t("Package")}
                            </span>
                            <span className="familysora600" style={{ fontSize: '12px', color: '#000', direction: 'ltr' }}>
                              {get_lang(bookingInvoiceInfo?.packageName, appState.langValue) || get_lang(invoiceData?.package?.name, appState.langValue)}
                            </span>
                          </div>
                        )}

                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center', 
                          padding: '10px 0', 
                          borderBottom: '1px solid #f0f0f0',
                          direction: appState.langValue === "ar" ? "rtl" : "ltr"
                        }}>
                          <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span>📅</span> {t("Booking Date")}
                          </span>
                          <span className="familysora600" style={{ fontSize: '12px', color: '#000', direction: 'ltr' }}>
                            {(bookingInvoiceInfo?.bookingDate || invoiceData?.booking_date) 
                              ? moment(bookingInvoiceInfo?.bookingDate || invoiceData?.booking_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
                              : 'N/A'} {bookingInvoiceInfo?.bookingTime && `(${bookingInvoiceInfo.bookingTime})`}
                          </span>
                        </div>

                        {invoiceData?.transaction?.amount && (
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            padding: '10px 0', 
                            borderBottom: '1px solid #f0f0f0',
                            direction: appState.langValue === "ar" ? "rtl" : "ltr"
                          }}>
                            <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>💰</span> {t("Total Amount") || t("Total")}
                            </span>
                            <span className="familysora600" style={{ fontSize: '15px', color: '#000', direction: 'ltr', fontWeight: 'bold' }}>
                              {invoiceData?.transaction?.amount} {apiState?.storeInfo?.currencySymbol || 'KWD'}
                            </span>
                          </div>
                        )}

                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center', 
                          padding: '10px 0',
                          direction: appState.langValue === "ar" ? "rtl" : "ltr"
                        }}>
                          <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span>📝</span> {t("invoice.reservation-number") || t("Reservation Number")}
                          </span>
                          <span className="familysora600" style={{ fontSize: '12px', color: '#000', direction: 'ltr' }}>
                            #{decodedId}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Pay Button */}
                <div className="text-center mt-3" style={{ width: '100%', padding: '0 16px' }}>
                  <div className="btn-container">
                    <Button
                      variant="contained"
                      className={`nextBtn text-capitalize d-flex align-items-center ${storeInfo?.payments?.length > 0 ? "justify-content-between" : "justify-content-center"}`}
                      onClick={() => !isPaymentLoading && setPaymentMethodPopUp(true)}
                      disabled={isPaymentLoading}
                      style={{ width: '100%' }}
                    >
                      {isPaymentLoading ? (
                        <div className="d-flex align-items-center justify-content-center" style={{ width: '100%', gap: '10px' }}>
                          <CircularProgress size={20} style={{ color: '#fff' }} />
                          <strong className="familysora400">{t("Processing") || "Processing..."}</strong>
                        </div>
                      ) : (
                        <>
                          <strong className="familysora400">{t("custom-msg.CheckOut") || "Pay"}</strong>
                          {storeInfo?.payments && storeInfo?.payments?.length > 0 && (
                            <div className="iconsParent d-flex justify-content-center">
                              {storeInfo?.payments?.map((item: any, index: any) => {
                              
                                return (
                                  <React.Fragment key={index}>
                                    {item == "knet" && (
                                      <span className="iconsBg">
                                        <img className="img-pr" src={knetSmall} alt=""  width={18}/>
                                      </span>
                                    )}
                                    {item == "card" && (
                                      <span className="iconsBg">
                                        <img className="img-pr" src={credit} alt=""  width={20}/>
                                      </span>
                                    )}
                                    {item == "apple_pay" && (
                                      <span className="iconsBg">
                                        <img className="img-pr" src={applePayIcon} alt=""  width={20}/>
                                      </span>
                                    )}
                                  </React.Fragment>
                                );
                              })}
                            </div>
                          )}
                        </>
                      )}
                    </Button>
                  </div>
                </div>
                {paymentMethodPopUp && (
                  <PaymentMethods
                    setCardDetails={setcardDetails}
                    handleCheckoutFunc={handleCheckoutFunc}
                    paymentMethod={paymentMethod}
                    setPaymentMethod={setPaymentMethod}
                    childRef={childRef}
                    setTapId={setTapId}
                    setButtonLoading={isPaymentLoading}
                    status={"checkout"}
                    goToAuth={goToAuth}
                    invoice_total={ Number(invoiceData?.transaction?.amount)}
                    otpIsRequired={!!storeInfo?.otp}
                  />
                )}
              </div>
            ) : (
              <>
              <div className="qrcodeParent d-flex flex-column align-items-center mt-3">
              <div className="App">
                
                <div className="d-flex justify-content-center" ref={ref} />
                <div
                  className="d-flex mt-2 inputWrapper"
                  style={styles.inputWrapper}
                ></div>
              </div>

              <div style={{ width: '100%' }}>
                {(invoiceData?.transaction?.status == "Success" || !paidByCash) && (
                  <>
                    <h1 className="text-center success familysora700" style={{ fontSize: '18px', margin: '12px 0 8px 0' }}>
                      {t("invoice.you-booked-successfully")}!
                    </h1>
                    {(invoiceData && paidByCash) && (
                  <div className="row mx-0 mt-3 mb-3" style={{ width: '100%' }}>
                    <div className="col-12" style={{
                      backgroundColor: '#ffffff',
                      borderRadius: '12px',
                      padding: '16px',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                      border: '1px solid #e8e8e8'
                    }}>
                      {/* Invoice Details List */}
                      <div style={{ marginBottom: '12px' }}>
                        {(bookingInvoiceInfo?.guests || invoiceData?.guests) && (
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            padding: '10px 0', 
                            borderBottom: '1px solid #f0f0f0',
                            direction: appState.langValue === "ar" ? "rtl" : "ltr"
                          }}>
                            <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>👥</span> {t("Guests")}
                            </span>
                            <span className="familysora600" style={{ fontSize: '15px', color: '#000', direction: 'ltr' }}>
                              {bookingInvoiceInfo?.guests || invoiceData?.guests || 'N/A'}
                            </span>
                          </div>
                        )}

                        {(bookingInvoiceInfo?.packageName || invoiceData?.package?.name) && (
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            padding: '10px 0', 
                            borderBottom: '1px solid #f0f0f0',
                            direction: appState.langValue === "ar" ? "rtl" : "ltr"
                          }}>
                            <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>📦</span> {t("Package")}
                            </span>
                            <span className="familysora600" style={{ fontSize: '12px', color: '#000', direction: 'ltr' }}>
                              {get_lang(bookingInvoiceInfo?.packageName, appState.langValue) || get_lang(invoiceData?.package?.name, appState.langValue)}
                            </span>
                          </div>
                        )}

                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center', 
                          padding: '10px 0', 
                          borderBottom: '1px solid #f0f0f0',
                          direction: appState.langValue === "ar" ? "rtl" : "ltr"
                        }}>
                          <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span>📅</span> {t("Booking Date")}
                          </span>
                          <span className="familysora600" style={{ fontSize: '12px', color: '#000', direction: 'ltr' }}>
                            {(bookingInvoiceInfo?.bookingDate || invoiceData?.booking_date) 
                              ? moment(bookingInvoiceInfo?.bookingDate || invoiceData?.booking_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
                              : 'N/A'} {bookingInvoiceInfo?.bookingTime && `(${bookingInvoiceInfo.bookingTime})`}
                          </span>
                        </div>

                        {invoiceData?.transaction?.amount && (
                          <div style={{ 
                            display: 'flex', 
                            justifyContent: 'space-between', 
                            alignItems: 'center', 
                            padding: '10px 0', 
                            borderBottom: '1px solid #f0f0f0',
                            direction: appState.langValue === "ar" ? "rtl" : "ltr"
                          }}>
                            <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <span>💰</span> {t("Total Amount") || t("Total")}
                            </span>
                            <span className="familysora600" style={{ fontSize: '15px', color: '#000', direction: 'ltr', fontWeight: 'bold' }}>
                              {invoiceData?.transaction?.amount} {apiState?.storeInfo?.currencySymbol || 'KWD'}
                            </span>
                          </div>
                        )}

                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center', 
                          padding: '10px 0',
                          direction: appState.langValue === "ar" ? "rtl" : "ltr"
                        }}>
                          <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span>📝</span> {t("invoice.reservation-number") || t("Reservation Number")}
                          </span>
                          <span className="familysora600" style={{ fontSize: '12px', color: '#000', direction: 'ltr' }}>
                            #{decodedId}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                )} 
                    <p className="text-center reserve familysora700" style={{ fontSize: '15px', margin: '0 0 6px 0' }}>
                      {t("invoice.reservation-number")}: #{decodedId}
                    </p>
                    <p className="text-center displaytext familysora400" style={{ fontSize: '12px', margin: '0 0 8px 0' }}>
                      {t("invoice.you-can-use-this-qr-code-at-the-location")}
                    </p>
                  </>
                )}

                
                {( (invoiceData?.transaction && invoiceData?.transaction?.status != "Success" && !paidByCash) ||  (invoiceData?.status?.id == 5 && invoiceData?.status?.id == 6))  && (
                  <>
                  <div>
                    <h1 className="text-center   canceled familysora700">
                      {t("Your Booking is cancelled.")}!
                    </h1>

                    <div className="text-center">
                      {/* <img
                        className="mb-1"
                        src={cancelIcon}
                        alt="cancelIcon"
                        width={150}
                        /> */}
                    </div>
                    <h2 className="text-center displaytext familysora400" onClick={()=> navigate(`/${invoiceData?.branch?.slug}`)} style={{cursor: "pointer"}}>
                      {t("Pleas try again")}
                    </h2>
                    </div>
                    
                    <NewNextBtn
                        label={t("Try Again")}
                        handleCheckout={ ()=> navigate(`/${invoiceData?.branch?.slug}`) }
                      // handleCheckout={undefined}
                      />
                  </>
                )}

              </div>
            </div>
            {/* <span><QrCodeIcon /></span> */}

            {(invoiceData?.transaction?.status == "Success" ||  ( invoiceData?.transaction == null &&  invoiceData?.status?.id != 5 && invoiceData?.status?.id != 6) || paidByCash) && (
              <>
                <ShareInvoiceQrcode />

                {/* Booking Details Section - Compact Mobile */}
                {showThis && <div className="row mx-0 mt-2 mb-2">
                  <div className="col-12" style={{
                    backgroundColor: '#ffffff',
                    borderRadius: '12px',
                    padding: '16px',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
                    border: '1px solid #e8e8e8'
                  }}>
                    {/* Compact Info List */}
                    <div style={{ marginBottom: '12px' }}>
                     {(bookingInvoiceInfo?.guests || invoiceData?.guests) && <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        padding: '10px 0', 
                        borderBottom: '1px solid #f0f0f0' ,
                        direction: appState.langValue === "ar" ? "rtl" : "ltr"
                      }}>
                        <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span>👥</span> {t("Guests")}
                        </span>
                        <span className="familysora600" style={{ fontSize: '15px', color: '#000', direction: 'ltr' }}>
                          {bookingInvoiceInfo?.guests || invoiceData?.guests || 'N/A'}
                        </span>
                      </div>}


                      {(bookingInvoiceInfo?.packageName || invoiceData?.package?.name) && (
                        <div style={{ 
                          display: 'flex', 
                          justifyContent: 'space-between', 
                          alignItems: 'center', 
                          padding: '10px 0', 
                          borderBottom: '1px solid #f0f0f0' ,
                          direction: appState.langValue === "ar" ? "rtl" : "ltr"
                        }}>
                          <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span>📦</span> {t("Package")}
                            </span>
                            <span className="familysora600" style={{ fontSize: '12px', color: '#000', direction: 'ltr' }}>
                              {get_lang(bookingInvoiceInfo?.packageName, appState.langValue) || get_lang(invoiceData?.package?.name, appState.langValue)}
                            </span>
                          </div>
                        )}

                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        padding: '10px 0', 
                        borderBottom: '1px solid #f0f0f0' ,
                        direction: appState.langValue === "ar" ? "rtl" : "ltr"
                      }}>
                        <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span>📅</span> {t("Booking Date")}
                        </span>
                        <span className="familysora600" style={{ fontSize: '12px', color: '#000', direction: 'ltr' }}>
                          {(bookingInvoiceInfo?.bookingDate || invoiceData?.booking_date) 
                            ? moment(bookingInvoiceInfo?.bookingDate || invoiceData?.booking_date, 'YYYY-MM-DD').format('DD/MM/YYYY')
                            : 'N/A'} {bookingInvoiceInfo?.bookingTime && `(${bookingInvoiceInfo.bookingTime})`}
                        </span>
                      </div>

                      <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        padding: '10px 0', 
                        borderBottom: '1px solid #f0f0f0' ,
                        direction: appState.langValue === "ar" ? "rtl" : "ltr"
                      }}>
                        <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span>📝</span> {t("Created On")}
                        </span>
                        <span className="familysora600" style={{ fontSize: '12px', color: '#000',  direction: 'ltr' }}>
                          {bookingInvoiceInfo?.bookingCreateDate && bookingInvoiceInfo?.bookingCreateDate !== 'N/A'
                            ? bookingInvoiceInfo.bookingCreateDate
                            : 'N/A'} {bookingInvoiceInfo?.bookingCreateTime && bookingInvoiceInfo?.bookingCreateTime !== 'N/A' ? `(${bookingInvoiceInfo.bookingCreateTime})` : ''}
                        </span>
                      </div>

                      {bookingInvoiceInfo?.paymentMethod || invoiceData?.transaction?.payment_source && <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center', 
                        padding: '10px 0', 
                        borderBottom: '1px solid #f0f0f0' ,
                        direction: appState.langValue === "ar" ? "rtl" : "ltr"

                      }}>
                        <span className="familysora500" style={{ fontSize: '12px', color: '#666', display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span>💳</span> {t("Payment")}
                        </span>
                        <span className="familysora600" style={{ fontSize: '12px', color: '#000', textTransform: 'capitalize', direction: 'ltr' }}>
                          {bookingInvoiceInfo?.paymentMethod || invoiceData?.transaction?.payment_source || 'Cash'}
                        </span>
                      </div>}

                      
                    </div>

                    {/* Compact Restaurant Notes */}
                    <div style={{
                      backgroundColor: '#fffbf0',
                      borderRadius: '8px',
                      padding: '12px',
                      border: '1.5px solid #ffd966',
                      direction: appState.langValue === "ar" ? "rtl" : "ltr"
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '8px' }}>
                        <span style={{ fontSize: '15px' }}>📝</span>
                        <span className="familysora600" style={{ fontSize: '12px', color: '#d97706' }}>
                          {t("Important Notes")}
                        </span>
                      </div>
                      
                      {/* <div className="familysora400" style={{ fontSize: '11px', lineHeight: '1.6', color: '#6b5f00' }}>
                        <div style={{ marginBottom: '6px' }}>
                          <strong>•</strong> 2-hour seating • Arrive 15 mins early
                        </div>
                        <div style={{ marginBottom: '6px' }}>
                          <strong>•</strong> Desert venue (allow extra time)
                        </div>
                        <div>
                          <strong>•</strong> Dress: Casual Chic (No sportswear)
                        </div>
                      </div> */}

                      <div className="familysora400" style={{ fontSize: '10px', lineHeight: '1.7', color: '#6b5f00',  direction: appState.langValue === "ar" ? "rtl" : "ltr"}}>
                        {branchSlug === 'kul-kuwait-city' ? (
                          <>
                            <div style={{ marginBottom: '8px', textAlign: appState.langValue === "ar" ? "right" : "left" }}>
                              <strong style={{ color: '#d97706' }}>•</strong> {t('Your table will be held for 15 minutes after your reservation time.')}
                            </div>
                            <div style={{ marginBottom: '8px', textAlign: appState.langValue === "ar" ? "right" : "left" }}>
                              <strong style={{ color: '#d97706' }}>•</strong> {t('Dining time is limited to 90 minutes per reservation.')}
                            </div>
                            <div style={{ marginBottom: '8px', textAlign: appState.langValue === "ar" ? "right" : "left" }}>
                              <strong style={{ color: '#d97706' }}>•</strong> {t('Table requests are subject to availability and cannot be guaranteed.')}
                            </div>
                            <div style={{ marginBottom: '8px', textAlign: appState.langValue === "ar" ? "right" : "left" }}>
                              <strong style={{ color: '#d97706' }}>•</strong> {t('Please notify us as early as possible if you need to cancel or modify your reservation.')}
                            </div>
                            <div style={{ textAlign: appState.langValue === "ar" ? "right" : "left" }}>
                              <strong style={{ color: '#d97706' }}>•</strong> {t('During peak hours, a short waiting time may occasionally occur as we prepare your table. We appreciate your patience and understanding.')}
                            </div>
                          </>
                        ) : (
                          <>
                            <div style={{ marginBottom: '8px' , textAlign: appState.langValue === "ar" ? "right" : "left" }}>
                              <strong  style={{color: '#d97706'}}>• {t('Dining Experience')}:</strong> {t('Each reservation is a strict 1.5-hour seating to preserve the flow of the experience.')}
                            </div>
                            <div style={{ marginBottom: '8px' , textAlign: appState.langValue === "ar" ? "right" : "left"   }}>
                              <strong  style={{color: '#d97706'}}   > •  {t('Arrival')}:</strong> {t('Please arrive 15 mins before reservation time, as late arrivals may shorten your service.')}  
                            </div>
                            <div style={{ marginBottom: '8px' , textAlign: appState.langValue === "ar" ? "right" : "left"   }}>
                              <strong  style={{color: '#d97706'}}   >   • {t('Location')}:</strong> {t('Allow extra time for transport and walking within the desert venue.')} 
                            </div>
                            <div style={{ textAlign: appState.langValue === "ar" ? "right" : "left"   }}>
                              <strong  style={{color: '#d97706'}}   >  • {t('Dress Code')}:</strong> {t('Casual Chic (Sportswear and Casual is not allowed) Try to be Elegant.')} 
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                 </div>}
              
                  {/* Add bottom padding when button is fixed */}
                  {/* {showThis && <div style={{ height: '80px' }}></div>} */}
              
                  {/* Fixed Location Button at Bottom */}
                  { showThis && <div 
                    style={{
                      position: 'sticky',
                      bottom: '0',
                      left: '0',
                      right: '0',
                      padding: '12px 16px',
                      backgroundColor: 'transparent',
                      // boxShadow: '0 -4px 12px rgba(0,0,0,0.1)',
                      zIndex: 1000,
                      // borderTop: '1px solid #e0e0e0'
                    }}
                  >
                    <button 
                      className="familysora600"
                      onClick={() => window.open(
                        branchSlug === 'kul-kuwait-city'
                          ? 'https://maps.app.goo.gl/GqCBabFRVBMSiMpq6?g_st=iw'
                          : 'https://maps.app.goo.gl/SThu1uJTcFyW6kmf8?g_st=iw',
                        '_blank'
                      )}
                      style={{
                        width: '100%',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        backgroundColor: '#000000',
                        borderRadius: '10px',
                        border: 'none',
                        padding: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '10px',
                        color: '#ffffff',
                        fontSize: '15px',
                        direction: appState.langValue === "ar" ? "rtl" : "ltr"
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#333333';
                        e.currentTarget.style.transform = 'scale(1.02)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#000000';
                        e.currentTarget.style.transform = 'scale(1)';
                      }}
                    >
                      <LocationOnIcon 
                        style={{ 
                          fontSize: '22px', 
                          color: '#ffffff'
                        }} 
                      />
                      <span>{t("Get Directions")}</span>
                    </button>
                  </div>}

                { false && <div className="row mx-0 d-flex justify-content-center">
                  <Button
                    onClick={() => handleCalendarEvent()}
                    className={` py-3 px-4 shareBtn calendarBtn col-12 familysora600 mt-2 justify-content-center ${
                      appState.langValue === "ar"
                        ? " familyGraphikArabic600"
                        : ""
                    }`}
                  >
                    {" "}
                    <span></span>{" "}
                    <span>
                      {" "}
                      <CalendarMonthIcon />{" "}
                    </span>{" "}
                    <span className="text-capitalize familysora600 mx-2 pt-1 ">
                      Add to Calendar
                    </span>{" "}
                  </Button>
                </div>}
              </>
            )}
              </>
            )}
          </div>
        </div>
      )}
    </React.Fragment>
      )}
    </React.Fragment>
  );
};  

const styles = {
  inputWrapper: {
    display: "flex",
    justifyContent: "space-between",
  },
  inputBox: {
    width: "100%",
    margin: "0px",
  },
};
export default withTranslation()(Invoice);
